import { useState, useEffect } from "react";
import { WIDE_BREAKPOINT } from "../theme/tokens";

/* ---------------------------------------------------------------
   RESPONSIVE — two-tier system. "compact" covers phones and narrow
   tablets (portrait): a centered single column with a bottom tab
   bar. "wide" covers landscape tablets and desktop: a persistent
   left rail replaces the bottom bar and content gets room to
   breathe (grids, wider charts). A single JS breakpoint drives the
   structural switch (bottom nav vs. rail); everything inside a
   screen that can reflow on its own (card grids) uses CSS auto-fill
   instead of extra JS branching.
------------------------------------------------------------------ */
export function useBreakpoint() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 390
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    let raf = null;
    const onResize = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        setWidth(window.innerWidth);
        raf = null;
      });
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
  return {
    width,
    isWide: width >= WIDE_BREAKPOINT,
    isDesktop: width >= 1200,
  };
}